import { render, staticRenderFns } from "./bar-golongan.vue?vue&type=template&id=1b338244"
import script from "./bar-golongan.vue?vue&type=script&lang=js"
export * from "./bar-golongan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports